import { notFound } from 'next/navigation';

import { whitelabelConfig } from '@/brands';
import { LuckySequencyType } from '@/types/enums/HighlightedRaffle';

/**
 * Jogos liberados por padrão para qualquer marca que não declare `availableGames`.
 * Roleta e Raspadinha são universais; jogos exclusivos (ex.: Pião da Sorte / SPINNING_TOP,
 * exclusivo do SBT) precisam ser habilitados explicitamente na config da marca.
 */
const DEFAULT_AVAILABLE_GAMES: LuckySequencyType[] = [
  LuckySequencyType.LUCKY_WHEEL,
  LuckySequencyType.SCRATCHER,
];

/**
 * Bloqueia (404) o acesso a uma página de jogo quando o tipo de jogo não está habilitado
 * para a marca atual (`NEXT_PUBLIC_WL_CODE`). Mantém jogos exclusivos restritos à marca
 * correta — ex.: Pião da Sorte (SPINNING_TOP) só no SBT.
 *
 * Como `whitelabelConfig` é uma constante de build, a checagem é estática e roda no server
 * antes de qualquer fetch ou render, funcionando inclusive para usuários deslogados.
 *
 * Marcas que não definem `availableGames` herdam o default (roleta + raspadinha).
 */
export function assertGameEnabledForBrand(game: LuckySequencyType): void {
  const enabled = whitelabelConfig.availableGames ?? DEFAULT_AVAILABLE_GAMES;

  if (!enabled.includes(game)) {
    notFound();
  }
}
